import React from "react";
import { Container, Row, Col } from "reactstrap";
import aboutImg from "../assests/images/about-us.png";

const points = [
  "Instant help across core study tasks",
  "Clear outputs you can revise and reuse",
  "One toolkit instead of five tabs",
];

const AboutUs = () => {
  return (
    <section className="bg-white py-20">
      <Container>
        <Row className="items-center gy-5 gx-4 gx-lg-5">
          <Col lg="6" md="6">
            <div className="relative">
              <div className="absolute left-4 top-4 -z-0 h-full w-full rounded-3xl bg-brand-soft max-md:left-2 max-md:top-2" />
              <img
                src={aboutImg}
                alt="Students collaborating with EzShiksha tools"
                className="relative z-[1] block w-full animate-float rounded-3xl"
              />
            </div>
          </Col>

          <Col lg="6" md="6">
            <p className="section-label">About us</p>
            <h2 className="mb-4">Learning support that keeps pace with you</h2>
            <p className="mb-6">
              EzShiksha helps students move from stuck to sorted — instant math
              solutions, concise notes from long text, grammar polish, and
              effortless text extraction from images. Built to cut friction so
              you can focus on understanding.
            </p>
            <ul className="m-0 flex list-none flex-col gap-3.5 p-0">
              {points.map((point) => (
                <li
                  key={point}
                  className="flex items-start gap-2.5 font-display text-base font-medium leading-snug text-brand-forest"
                >
                  <i className="ri-check-line mt-0 inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-soft text-base text-brand-teal-dark" />
                  {point}
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
